var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import createElement from '../logical-components/createElement';
// Global helpers
import svgs from './svgs';
import renderText from '../logical-components/renderText';
import Input from './input/field';
import Button from './input/button';
import './scss/rememberMe-actions.scss';
import constructName from '../logical-components/constructName';
// Message
var MessageComponent = function () {
    var container = createElement('div', [
        { type: 'class', value: '_msnlq-ae-c' },
    ]);
    container.innerHTML = "\n        <div class='_msnlq-ae-s-me'>\n            <h4> ".concat(renderText('actions.submit.success.title'), " </h4>\n            <p> ").concat(renderText('actions.submit.success.message'), " </p>\n        </div>\n        <div class='_msnlq-ae-e-me'>\n            <h4> ").concat(renderText('actions.submit.error.title'), " </h4>\n            <p> ").concat(renderText('actions.submit.error.message'), " </p>\n        </div>\n    ");
    return container;
};
var actions = [
    {
        icon: svgs.write,
        title: renderText('actions.write.title'),
        type: 'write',
    },
    {
        icon: svgs.flower,
        title: renderText('actions.flower.title'),
        type: 'flower',
    },
    {
        icon: svgs.candle,
        title: renderText('actions.candle.title'),
        type: 'candle',
    },
];
// Forms
var FormsComponent = function (_a) {
    var type = _a.type, handleChange = _a.handleChange, onSubmit = _a.onSubmit;
    var template = createElement('div');
    if (type === 'write') {
        template.appendChild(Input({
            label: renderText('actions.form.message.label'),
            placeholder: renderText('actions.form.message.placeholder'),
            onChange: function (e) {
                handleChange(type, 'message', e.target.value);
            },
            id: "".concat(type, "-form-message"),
            fieldType: 'textarea',
        }));
    }
    template.appendChild(Input({
        label: renderText('actions.form.firstName.label'),
        placeholder: renderText('actions.form.firstName.placeholder'),
        onChange: function (e) {
            handleChange(type, 'firstName', e.target.value);
        },
        id: "".concat(type, "-form-firstName"),
    }));
    template.appendChild(Input({
        label: renderText('actions.form.lastName.label'),
        placeholder: renderText('actions.form.lastName.placeholder'),
        onChange: function (e) {
            handleChange(type, 'lastName', e.target.value);
        },
        id: "".concat(type, "-form-lastName"),
    }));
    template.appendChild(Input({
        label: renderText('actions.form.email.label'),
        labelInfo: renderText('actions.form.email.labelInfo'),
        placeholder: renderText('actions.form.email.placeholder'),
        onChange: function (e) {
            handleChange(type, 'email', e.target.value);
        },
        id: "".concat(type, "-form-email"),
    }));
    template.appendChild(Button({
        label: renderText('actions.form.button.label'),
        onClick: function () {
            onSubmit(type);
        },
    }));
    return template;
};
// Tabs
var TabsComponent = function (state, handleUpdate, onSubmit, handleClick) {
    var template = createElement('div');
    template.innerHTML = "\n        <div class='_msnlq-tabs'>\n        </div>\n        <div class='_msnlq-tabs-contentblocks'>\n        </div>\n    ";
    // generate Tabs
    var tabWrapper = template.querySelector('._msnlq-tabs');
    var tabContentWrapper = template.querySelector('._msnlq-tabs-contentblocks');
    actions.forEach(function (action) {
        // Build tab
        var tab = createElement('div', [
            { type: 'class', value: "_msnlq-tab _msnlq-tab-".concat(action.type) },
        ]);
        tab.innerHTML = "\n            <span class='_msnlq-icons'> ".concat(action.icon, " </span>\n            <span class='_msnlq-tab-text'> ").concat(action.title, " </span>\n        ");
        tab.addEventListener('click', function () {
            handleClick(action.type);
        });
        tabWrapper.appendChild(tab);
        // Build content
        var tabContent = createElement('div', [
            {
                type: 'class',
                value: "_msnlq-tab-content _msnlq-tab-content-".concat(action.type),
            },
        ]);
        tabContent.appendChild(FormsComponent({
            type: action.type,
            onSubmit: onSubmit,
            handleChange: handleUpdate,
        }));
        tabContentWrapper.appendChild(tabContent);
    });
    return template;
};
// Visual component
var rememberMeActions = function (config, section, onSubmit, onClose, reply) {
    var _a;
    var wrapper = createElement('div');
    wrapper.className = '_msnlq-act-wrapper _mslq-ct-wrapper-cl';
    wrapper.innerHTML = "<div class='_msnlq-act-content'>\n        <div class='_msnlq-act-in-content'>\n\n        </div>\n        <div class='_msnlq-act-close'> ".concat(svgs.close, " </div>\n    </div>\n    ");
    if (reply) {
        wrapper.classList.add('_msnlq-limited-actions');
    }
    wrapper.querySelector('._msnlq-act-close').addEventListener('click', function () {
        onClose();
    });
    var actionsWrapper = wrapper.querySelector('._msnlq-act-in-content');
    if ((_a = section === null || section === void 0 ? void 0 : section.options) === null || _a === void 0 ? void 0 : _a.hideActions) {
        return actionsWrapper;
    }
    var activeState = 'write';
    // Actions data
    var state = {
        write: {
            message: '',
            firstName: '',
            lastName: '',
            email: '',
            videoUrl: '',
            image: '',
        },
        candle: {
            firstName: '',
            lastName: '',
            email: '',
        },
        flower: {
            firstName: '',
            lastName: '',
            email: '',
        },
    };
    var handleUpdate = function (type, key, value) {
        var _a, _b;
        state = __assign(__assign({}, state), (_a = {}, _a[type] = __assign(__assign({}, state[type]), (_b = {}, _b[key] = value, _b)), _a));
    };
    var handleSubmit = function () {
        onSubmit(activeState, state);
    };
    var processActiveTabs = function () {
        // Correct / reset tabs
        var activeTab = actionsWrapper.querySelector('.msnlq-active-tab');
        if (activeTab) {
            activeTab.classList.remove('msnlq-active-tab');
        }
        var activeContent = actionsWrapper.querySelector('.msnlq-active-content');
        if (activeContent) {
            activeContent.classList.remove('msnlq-active-content');
        }
        // Set correct tabs
        actionsWrapper
            .querySelector("._msnlq-tab-".concat(activeState))
            .classList.add('msnlq-active-tab');
        actionsWrapper
            .querySelector("._msnlq-tab-content-".concat(activeState))
            .classList.add('msnlq-active-content');
    };
    var handleClick = function (type) {
        var _a;
        // Update state
        activeState = type;
        processActiveTabs();
        // Send analytics
        if ((_a = window === null || window === void 0 ? void 0 : window._mensenlinqEvents) === null || _a === void 0 ? void 0 : _a.emit) {
            window._mensenlinqEvents.emit('statistics', {
                type: 'actionsTabClicked',
                payload: {
                    time: Date.now(),
                    location: window.location.href,
                    action: type,
                },
            });
        }
    };
    // Render
    //
    actionsWrapper.innerHTML = "<h3> ".concat(renderText('rememberMe.actions'), " </h3>");
    actionsWrapper.appendChild(TabsComponent(state, handleUpdate, handleSubmit, handleClick));
    actionsWrapper.appendChild(MessageComponent());
    processActiveTabs();
    return wrapper;
};
var rememberMeActionWrapper = function (config, section, onSubmit, reply, item) {
    var overlayOpen = false;
    var actionsWrapper = createElement('div');
    actionsWrapper.className = '_msnlq-act-container';
    actionsWrapper.innerHTML = "<div class='_mnslq-ac'>\n        <div>\n            <div class='_mnslq-ac-icon'> ".concat(svgs.write, " </div>\n            <div class='_mnslq-ac-title'> \n                ").concat(reply
        ? renderText('rememberMe.reply', constructName(item))
        : renderText('rememberMe.condolence'), "\n                <span class='_msnlq-ac-arrow'> ").concat(svgs.arrow, " </span>\n            </div>\n            \n        </div>\n    </div>");
    var toggleOverlay = function () {
        overlayOpen = !overlayOpen;
        var ele = actionsWrapper.querySelector('._msnlq-act-wrapper');
        var rootWrapper = ele.closest('._mnslq-rememberMewrapper');
        if (overlayOpen) {
            ele.classList.remove('_mslq-ct-wrapper-cl');
        }
        else {
            ele.classList.add('_mslq-ct-wrapper-cl');
            // RESET form
            rootWrapper.classList.remove('_msnlq-posted-true');
            rootWrapper.querySelectorAll('._msng-input-wrapper input, ._msng-input-wrapper textarea').forEach(function (el) {
                el.value = '';
            });
        }
    };
    actionsWrapper.appendChild(createElement('div', [{ type: 'class', value: '_msnlq-action-embed' }]));
    actionsWrapper
        .querySelector('._msnlq-action-embed')
        .appendChild(rememberMeActions(config, section, onSubmit, toggleOverlay, reply));
    actionsWrapper.querySelector('._mnslq-ac').addEventListener('click', function () {
        toggleOverlay();
    });
    return actionsWrapper;
};
export default rememberMeActionWrapper;
